export function mapAriaProps(props = {}) {
    return {
        "aria-controls": props.controls,
        "aria-describedby": props.describedby,
        "aria-expanded": props.expanded,
        "aria-haspopup": props.hasPopup,
        "aria-label": props.label,
        "aria-labelledby": props.labelledby,
        "aria-owns": props.owns,
        "aria-pressed": props.buttonPressed
    };
}
//# sourceMappingURL=index.js.map